import React from 'react';
import { Grid } from 'fw/forms';
import { Button } from 'fw/components';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExport } from '@fortawesome/free-solid-svg-icons';
import CertificationLink from 'areas/shared/components/formatter/CertificationLink';
import DateColor from 'areas/admin/shared/DateColor';
import AssigneeStatus from 'areas/admin/shared/AssigneeStatus';
import DaysOpen from 'areas/admin/shared/DaysOpen';
import FlagFormatter from 'areas/admin/shared/FlagFormatter';
import BoldFormatter from 'areas/admin/shared/BoldFormatter';
import DocumentStatus from 'areas/admin/shared/DocumentStatus';
import { Col, Row, Glyphicon } from 'react-bootstrap';
import * as App from 'modules/app/App';

const columns = [
	{ key: 'flags', name: 'Flag', width: 53, formatter: FlagFormatter, sortable: false },
	{ key: 'vobId', name: 'APP ID', width: 72, formatter: CertificationLink, getRowMetaData: (row) => row, sortable: true },
	{ key: 'type', name: 'APP TYPE', width: 110, sortable: true },
	{ key: 'sponsorTypeCode', name: 'S-TYPE', width: 60, formatter: BoldFormatter, sortable: true },
	{ key: 'discountCode', name: 'DISC. CODE', width: 85, sortable: true },
	{ key: 'certificationNumber', name: 'CERT#', width: 85, sortable: true },
	{ key: 'company', name: 'COMPANY', width: 150, sortable: true },
	{ key: 'dbaName', name: 'DBA', width: 150, sortable: true },
	{ key: 'companyFEIN', name: 'FEIN/EIN', width: 85, sortable: true },
	{ key: 'state', name: 'STATE', width: 65, sortable: true },
	{ key: 'veteran', name: 'VET NAME', width: 125, sortable: true },
	{ key: 'veteranSDVS', name: 'SDVS', formatter: DocumentStatus, width: 65, sortable: true },
	{ key: 'dD214Status', name: 'DD214', width: 80, formatter: DateColor, getRowMetaData: (row) => row, sortable: true },
	{ key: 'track', name: 'TRACK', formatter: DocumentStatus, width: 65, sortable: true },
	{ key: 'daysInDraft', name: 'DRAFT', formatter: DaysOpen, width: 80, sortable: true },
	{ key: 'daysSubmitted', name: 'SUB', formatter: DaysOpen, width: 95, sortable: true },
	{ key: 'declaration', name: 'DEC', formatter: DocumentStatus, width: 65, sortable: true },
	{ key: 'app', name: 'APP', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'APP' }), sortable: true },
	{ key: 'cert', name: 'CERT', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'CER' }), sortable: true },
	{ key: 'comm', name: 'COMM', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'COM' }), sortable: true },
	{ key: 'site', name: 'SITE', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'STR' }), sortable: true },
	{ key: 'final', name: 'FINAL', formatter: AssigneeStatus, getRowMetaData: (row) => ({ certificationKey: row.certificationKey, queueTypeCode: 'FIN' }), sortable: true }
];

class SearchQueueGrid extends React.Component {
	curRq

	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			originalRows: [],
			certificationStatusCode: props.certificationStatusCode,
			serverCount: null,
			currentPageIndex: 0,
			currentSortDirection: null,
			currentSortColumn: null
		};
	}

	onExportData = () => {
		const rq = this.curRq;

		new API().post(APIModules.Admin.url('/queue/searchQueueExport'), rq,
			{
				success: (sr) => {
					new API().download(sr.data);
				}
			});
	}

	onExecutiveReportSummary = () => {
		const rq = this.curRq;

		new API().post(APIModules.Admin.url('/queue/searchQueueExecutiveReportExport', rq), rq,
			{
				success: (sr) => {
					new API().download(sr.data);
				}
			});
	}

	onLoadMoreResults = () => {
		let rq = { ...this.props.searchParams };

		this.setState({
			currentPageIndex: this.state.currentPageIndex + 1
		}, () => {
			rq.pageIndex = this.state.currentPageIndex;
			rq.sortField = this.state.currentSortColumn;
			rq.sortDirection = this.state.currentSortDirection;
			this.search(rq, () => { }, true);
		});
	}

	componentWillReceiveProps(nextProps) {

		if (nextProps.certificationStatusCode !== this.props.certificationStatusCode)
			this.setState({
				certificationStatusCode: nextProps.certificationStatusCode
			});
	}

	search = (rq, callback, appendResults) => {
		this.curRq = rq;

		App.updateSearchQueueFilters(rq);
		rq.rowCount = this.props.rowCount;

		if (!appendResults)
			this.setState({ currentPageIndex: 0 });

		var state = {
			originalRows: []
		};

		new API().post(APIModules.Admin.url('/queue/searchQueue'), rq,
			{
				success: (r) => {
					//Needed for indicate target queue to CertificationLink component
					r.data.items.forEach(function (item) {
						item.selectedQueueTypeCode = rq.queueTypeCode;
					});

					let rows = r.data.items;
					let pageIndex = this.state.currentPageIndex;

					if (appendResults)
						rows = [...this.state.originalRows, ...r.data.items];
					else {
						rows = r.data.items;
						pageIndex = 0;
					}

					state = {
						originalRows: rows,
						rows: rows.slice(0),
						serverCount: r.data.count,
						pageIndex: pageIndex
					};

					// Store search results
					this.setState(state);

					// Callback
					if (callback)
						callback();
				}
			});

		return state;
	}

	onAssign = (certificationId) => {
		if (this.state.certificationStatusCode === "UNA" && this.props.onAssignReviewer)
			this.props.onAssignReviewer(certificationId);
	}

	onSort = (sortColumn, sortDirection) => {
		let rq = { ...this.props.searchParams };

		this.setState({
			currentPageIndex: 0,
			currentSortDirection: sortDirection !== 'NONE' ? sortDirection : null,
			currentSortColumn: sortColumn !== 'NONE' ? sortColumn : null
		}, () => {
			rq.pageIndex = this.state.currentPageIndex;
			rq.sortField = this.state.currentSortColumn;
			rq.sortDirection = this.state.currentSortDirection;

			this.search(rq, () => { }, false);
		});
	}

	render() {
		return (
			<React.Fragment>
				<Grid
					ref={(c) => { this._grid = c }}
					columns={columns}
					items={this.state.rows}
					height={400}
					className="table-condensed"
					rowKey="vobId"
					onChange={this.onAssign}
					onSort={this.onSort}
					name="default" />
					<hr />
					<Row style={{ paddingBottom: "6px" }}>
						<Col md={10} >
							{this.state.originalRows &&
								<Button
									id="btnExportCsv"
									onClick={this.onExportData}
									className="btn btn-default" >
									<FontAwesomeIcon icon={faFileExport} /> Export CSV
								</Button>
							}
							{this.state.originalRows && App.hasPrivilege("ExecutiveReportSummarySearch") &&
								<Button
									id="btnExecutiveReportSummary"
									onClick={this.onExecutiveReportSummary}
									style={{marginLeft:15}}
									className="btn btn-default" >
									<FontAwesomeIcon icon={faFileExport} /> Executive Report Summary
								</Button>
							}
						</Col>
						
						<Col md={2}>
							{this.state.serverCount !== null && 
							 this.state.serverCount !== undefined && 
							 this.state.serverCount > (this.state.pageIndex + 1) * this.props.rowCount &&
								<Button id="btnViewMoreResults" onClick={this.onLoadMoreResults} className="pull-right">
									<Glyphicon glyph="glyphicon glyphicon-repeat" style={{ marginRight: 10 }} />Show more results
								</Button>
							}
						</Col>
					</Row>
			</React.Fragment >
		)
	}
}

SearchQueueGrid.defaultProps = {
	rowCount: 100
};

export default SearchQueueGrid;




// WEBPACK FOOTER //
// ./src/areas/admin/certification/searchQueue/SearchQueueGrid.js